import FeeScheduleCategory, {
  FeeScheduleCategoryMaskedCurrency
} from "work/values/fee-schedule-category/fee-schedule-category";

export type WorkFeeScheduleCategoryAPIRequestPayload = {
  id?: string;
  name?: string;
  description?: string;
  billingCode?: string;
  feeRate?: number;
  feeCurrency?: string;
  feeUnit?: string;
};
export default class WorkFeeScheduleCategoryAPIRequest {
  id?: string;
  name?: string;
  description?: string;
  billingCode?: string;
  feeRate?: number;
  feeCurrency?: string;
  feeUnit?: string;

  constructor(category: FeeScheduleCategory | FeeScheduleCategoryMaskedCurrency) {
    if (!category.name) throw new Error("Fee Schedule Category name is required");
    this.id = category.id?.value;
    this.name = category.name.value;
    this.description = category.description?.value;
    this.billingCode = category.billingCode?.value;
    if (category instanceof FeeScheduleCategoryMaskedCurrency) {
      return;
    }
    this.feeRate = category.fee?.rate?.amount;
    this.feeCurrency = category.fee?.rate?.currency;
    this.feeUnit = category.fee?.unit ?? undefined;
  }

  public get payload(): WorkFeeScheduleCategoryAPIRequestPayload {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      billingCode: this.billingCode,
      feeRate: this.feeRate,
      feeCurrency: this.feeCurrency,
      feeUnit: this.feeUnit,
    };
  }
}
